import { render } from "./VpnLockOverlay.vue?vue&type=template&id=42da251c&scoped=true"
import script from "./VpnLockOverlay.vue?vue&type=script&lang=js"
export * from "./VpnLockOverlay.vue?vue&type=script&lang=js"

import "./VpnLockOverlay.vue?vue&type=style&index=0&id=42da251c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42da251c"]])

export default __exports__